/** DD-3862: the backend's usage limits, which get their own text instead of "could not answer". */
const LIMIT_MESSAGES = new Map([
    ['ASSISTANT_LIMIT_REACHED', 'help-drawer:ASSISTANT_LIMIT_REACHED'],
    ['ASSISTANT_BUSY', 'help-drawer:ASSISTANT_BUSY'],
]);

/** The translation key for why a question was not answered. */
export const assistantFailureKeyOf = (error: unknown): string => {
    const graphQLErrors = (error as { graphQLErrors?: Array<{ message?: unknown }> } | undefined)?.graphQLErrors;
    const code = Array.isArray(graphQLErrors) ? graphQLErrors[0]?.message : undefined;
    return (typeof code === 'string' && LIMIT_MESSAGES.get(code)) || 'help-drawer:ASSISTANT_FAILED';
};
